import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DashboardInvoiceReceiptAnalysis,
  DashboardInvoiceReceiptAnalysisParams,
  DashboardInvoiceReceiptParams,
  DashboardInvoiceReceiptStatistics,
  DashboardStickersAnalysis,
  DashboardStickersAnalysisParams,
  DashboardStickersStatistics,
  DashboardStickersStatisticsParams,
  DashboardTaxStatisticsResponse,
  SupersetResource
} from '~core/models/dashboard.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class StatisticService {
  private _httpClient = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);
  get apiUrl(): string {
    return this._apiConstantsService.statisticUrl;
  }

  getSupersetResource(
    chartId: string,
    params?: {
      startDateTime?: string;
      endDateTime?: string;
    }
  ): Observable<SupersetResource> {
    return this._httpClient.get<SupersetResource>(
      `${this.apiUrl}/superset/charts/${chartId}/data`,
      { params }
    );
  }

  invoiceStatistics(
    params?: DashboardInvoiceReceiptParams
  ): Observable<DashboardInvoiceReceiptStatistics> {
    return this._httpClient.get<DashboardInvoiceReceiptStatistics>(
      `${this.apiUrl}/superset/statistics/invoices-receipts`,
      { params }
    );
  }

  taxStatistics(
    params?: DashboardInvoiceReceiptParams
  ): Observable<DashboardTaxStatisticsResponse> {
    return this._httpClient.get<DashboardTaxStatisticsResponse>(
      `${this.apiUrl}/superset/analytics`,
      { params }
    );
  }

  consumptionAnalysis(
    params?: DashboardInvoiceReceiptAnalysisParams
  ): Observable<DashboardStickersAnalysis> {
    return this._httpClient.get<DashboardStickersAnalysis>(
      `${this.apiUrl}/superset/analytics`,
      { params }
    );
  }

  transactionAnalysis(
    params?: DashboardInvoiceReceiptAnalysisParams
  ): Observable<DashboardInvoiceReceiptAnalysis> {
    return this._httpClient.get<DashboardInvoiceReceiptAnalysis>(
      `${this.apiUrl}/superset/analytics`,
      { params }
    );
  }

  stickersStatistics(
    params?: DashboardStickersStatisticsParams
  ): Observable<DashboardStickersStatistics> {
    return this._httpClient.get<DashboardStickersStatistics>(
      `${this.apiUrl}/stickers/statistics`,
      { params }
    );
  }

  stickersAnalysis(
    params?: DashboardStickersAnalysisParams
  ): Observable<DashboardStickersAnalysis> {
    return this._httpClient.get<DashboardStickersAnalysis>(
      `${this.apiUrl}/stickers/analysis`,
      { params }
    );
  }
}
